/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconFilterUp = createReactComponent("filter-up", "IconFilterUp", [
  [
    "path",
    {
      d: "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v2",
      key: "svg-0"
    }
  ],
  ["path", { d: "M19 22v-6", key: "svg-1" }],
  ["path", { d: "M22 19l-3 -3l-3 3", key: "svg-2" }]
]);

export { IconFilterUp as default };
//# sourceMappingURL=IconFilterUp.js.map
